import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Calendar } from './calendar/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    Calendar
  ],
  imports: [
    CommonModule,
    DatePickerModule,
    FormsModule,
  ],
  exports: [
    Calendar,
  ]
})
export class CalendarModule { }
